// extracted by mini-css-extract-plugin
export default {"headerMenuNavLink":"headerMenuNavLink-2c8f","selected":"selected-1815","menu-label":"menu-label-af8d"};